import classes from "./Skills.module.css";

const Skills = () => {
	return (
		<>
			<div className={classes.skills}>
				<ul>
					<li>React</li>
					<li>Redux</li>
					<li>javascript</li>
					<li>jQuery</li>
					<li>webpack</li>
					<li>Firebase</li>
					<li>Docker</li>
					<li>PHP</li>
					<li>WordPress</li>
					<li>HTML5</li>
					<li>CSS3</li>
					<li>MySQL</li>
					<li>npm</li>
					<li>Gulp</li>
					<li>Linux</li>
					<li>ubuntu</li>
					<li>centOS</li>
					<li>Git / GitHub / GitLab</li>
				</ul>
			</div>
		</>
	);
};

export default Skills;
